import { useContext, useEffect, useRef } from 'react';
import WebSocketContext from '../context/WebSocketContext';

const eventCallbackMap = new Map();

export const useWebSocket = (eventType, callback) => {
  const { messageEmitter } = useContext(WebSocketContext);
  const previousCallback = useRef(null);

  useEffect(() => {
    if (!messageEmitter) return;
    if (eventCallbackMap.has(eventType)) {
      const oldCallback = eventCallbackMap.get(eventType);
      messageEmitter.off(eventType, oldCallback);
    }
    eventCallbackMap.set(eventType, callback);
    messageEmitter.on(eventType, callback);
    previousCallback.current = callback;
  }, [messageEmitter, eventType, callback]);

  return messageEmitter;
};
